// src/components/ErrorBoundary.js

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import "../css/ErrorHandler.css";
import colors from '../colors';

const ErrorBoundary = ({ children }) => {

  const [hasError, setHasError] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [goHome, setGoHome] = useState(false);

  useEffect(() => {
    if (hasError) {
      setHasError(false);
    }
  }, [location.key]);

  useEffect(() => {
    if (goHome) {
      setGoHome(false);
      navigate("/");
    }
  }, [goHome]);

  return (
    <ErrorBoundaryInner
      hasError={hasError}
      setHasError={setHasError}
      setGoHome={setGoHome}
      pathname={location.pathname}
    >

        
      {children}
    </ErrorBoundaryInner>
  );
};

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidUpdate(prevProps, _previousState) {
    if (!this.props.hasError && prevProps.hasError) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(_error, _errorInfo) {
    this.state.errorMessage = _error.message;
    this.props.setHasError(true);

    if (_error.message === "user is null" && !this.props.pathname.includes("tags"))
      this.props.setGoHome(true);
  }

  render() {
    return this.state.hasError ? (
      <div id="error-handler">
        {console.log("error: ", this.state.errorMessage)}

        <div id="error-title">
          <h2>خطای سرور</h2>
          <p>آخ آخ! یه خطایی پیش اومد...</p>
          <span style={{ fontSize: "10px" }}>{this.state.errorMessage}</span>
        </div>

        <div id="error-pic">
          <img src={require("../images/404.gif")} alt={process.env.REACT_APP_ALT} />
        </div>

        <div id="error-button">
          <Link to="/">
            <button>برگرد خونه</button>
          </Link>
        </div>
      </div>
    ) : (
      this.props.children
    );
  }
}

export default ErrorBoundary;
